import { render } from "./ObjectTypeLinks.vue?vue&type=template&id=57fc5f64"
import script from "./ObjectTypeLinks.vue?vue&type=script&lang=js"
export * from "./ObjectTypeLinks.vue?vue&type=script&lang=js"

import "./ObjectTypeLinks.vue?vue&type=style&index=0&id=57fc5f64&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.17.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__